import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
 
export class CMFService {

    private apiUrl = environment.apiUrl;
    constructor(private http: HttpClient) { }
    httpOptions = {
    headers: new HttpHeaders({       
      'Content-Type': 'application/json',
      Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token')
      },
    ),
  };

   public getCMFInterviewData() {
            const url = this.apiUrl + "CMF/GetCMFInterviewsData" ;
            return this.http.get<any>(url, this.httpOptions);
           
    }
    public GetCMFDashboardData(data: any) {  
      console.log("data in CMF Service : ",data); 
      const url = `${this.apiUrl}CMF/GetCMFDashboardData`;
      return this.http.post<any>(url,data,  this.httpOptions);
  }  
     
}


